<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>Notification Settings</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="2"
                md="4"
                sm="6"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'jobSetupForm', params: {id: 0} }"
                        >
                            New
                        </v-btn>
                    </template>
                    <span>New</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        outlined
                        single-line
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >   
                    <template v-slot:item.statusDescription="{ item }">
                        <v-chip
                            :color="getStatusColor(item.status)"
                            outlined
                            dark
                        >
                            {{ item.statusDescription }}
                        </v-chip>
                    </template>

                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'jobSetupForm'"
                            :showButtons="{
                                edit: true,
                                delete: true,
                                cancel: item.status === 1 ? true : false,
                                active: item.status === 0 ? true : false
                            }"
                            @confirmDelete="confirmDelete"
                            @confirmCancel="confirmCancel"
                            @confirmActive="confirmActive"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    export default ({

        components: {
            ActionList,
            ActionDialog
        },

        mixins: [Helpers],
        data: () => ({

            id: 0,

            loading: false,

            filter: {
                fastSearch: ''
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Job Status", value: "statusJobSelected.statusDescription", sortable: true },
                { text: "Work Order Status", value: "statusWorkOrderSelected.statusDescription", sortable: true },
                { text: "Create To Do?", value: "createToDoDescription", sortable: true },
                { text: "Send E-Mail?", value: "sendEmailDescription", sortable: true },
                { text: "Put Job On Hold?", value: "putOnHoldDescription", sortable: true },
                { text: "Title", value: "title", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listServiceProjectSetup: [],
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            filteredSearch: function() {

                if (this.listServiceProjectSetup != null && this.listServiceProjectSetup != undefined) {
                    return this.listServiceProjectSetup.filter((serviceProjectSetupFilter) => {
                        
                        const filter = this.filter.fastSearch.toLowerCase();

                        const title = serviceProjectSetupFilter.title.toLowerCase().match(filter)
                        const statusJobDescription = serviceProjectSetupFilter.statusJobDescription != null && serviceProjectSetupFilter.statusJobDescription != undefined ? serviceProjectSetupFilter.statusJobDescription.toLowerCase().match(filter) : ""
                        const createToDoDescription = serviceProjectSetupFilter.createToDoDescription != null && serviceProjectSetupFilter.createToDoDescription != undefined ? serviceProjectSetupFilter.createToDoDescription.toLowerCase().match(filter) : ""
                        const sendEmailDescription = serviceProjectSetupFilter.sendEmailDescription != null && serviceProjectSetupFilter.sendEmailDescription != undefined ? serviceProjectSetupFilter.sendEmailDescription.toLowerCase().match(filter) : ""
                        const putOnHoldDescription = serviceProjectSetupFilter.putOnHoldDescription != null && serviceProjectSetupFilter.putOnHoldDescription != undefined ? serviceProjectSetupFilter.putOnHoldDescription.toLowerCase().match(filter) : ""
                        const statusDescription = serviceProjectSetupFilter.statusDescription != null && serviceProjectSetupFilter.statusDescription != undefined ? serviceProjectSetupFilter.statusDescription.toLowerCase().match(filter) : ""
                        const id = serviceProjectSetupFilter.id.toString().match(filter);

                        if (title != null) { return title; } 
                        else if(statusJobDescription != null) { return statusJobDescription; } 
                        else if(createToDoDescription != null) { return createToDoDescription; } 
                        else if(sendEmailDescription != null) { return sendEmailDescription; } 
                        else if(putOnHoldDescription != null) { return putOnHoldDescription; }
                        else if(statusDescription != null) { return statusDescription; }
                        else { return id; }
                    });
                }
                else {
                    return null;
                }
            }
        },

        methods: {

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    case 1:
                        color = 'var(--color__main)';
                        break;

                    case 0:
                        color = 'var(--color__cinza_escuro)';
                        break;
                
                    default:
                        break;
                }

                return color
            },

            confirmDelete(id) {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will DELETE this register, confirm your decision?',
                    methodConfirm: this.delete,
                    params: id
                };

            },

            async delete(id) {

                this.showLoading();

                const result = await this.$store.dispatch("serviceProjectSetupModule/Delete", id);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmCancel(id) {

                this.statusId = 0;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will INACTIVATE this task, confirm your decision?',
                    methodConfirm: this.cancel,
                    params: id
                };
            },

            async cancel(id) {

                let statusId = this.statusId;

                this.showLoading();

                let result = await this.$store.dispatch("serviceProjectSetupModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            confirmActive(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this task, confirm your decision?',
                    methodConfirm: this.active,
                    params: id
                };

            },

            async active(id) {

                this.showLoading();
                let statusId = this.statusId;

                let result = await this.$store.dispatch("serviceProjectSetupModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();

                this.hideLoading();
            },

            async getRegisters() {
                this.listServiceProjectSetup = await this.$store.dispatch("serviceProjectSetupModule/List");
            },
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>
